module.exports = __webpack_public_path__ + "static/accessories-bg-9d9c3eab796c986fb2b0537d3f17ef75.jpg";